import { useGetAgendaItem } from "@/hooks/queryHooks/agendaItemHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate } from "react-router-dom";

export const AgendaItemDisplay = ({
  tenantId,
  agendaItemId,
}: {
  tenantId: string;
  agendaItemId: string;
}) => {
  const navigate = useNavigate();

  const { data: agendaItem } = useGetAgendaItem(tenantId, agendaItemId);

  const handleView = () => {
    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getAgendaItemPath(agendaItemId));
  };

  return (
    <div className="p-2 mb-2 bg-secondary bg-opacity-75 rounded-lg text-secondary-foreground">
      <div className="flex flex-row justify-between gap-x-2">
        <h3 className="text-lg">{agendaItem?.name ?? "..."}</h3>
        <Button type="button" onClick={() => handleView()}>
          View
        </Button>
      </div>
      <div className="flex flex-row justify-between">
        <div>
          {agendaItem?.documents?.map((doc) => (
            <div key={doc.id}>{doc.name}</div>
          ))}
        </div>
        <div></div>
      </div>
    </div>
  );
};
